import { render, staticRenderFns } from "./UpdateGuardianContact.vue?vue&type=template&id=05822169"
import script from "./UpdateGuardianContact.vue?vue&type=script&lang=js"
export * from "./UpdateGuardianContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports